import React from 'react';
import classNames from 'classnames';
import Requests from '../../../api/requests';
import './test-field.scss';
import _ from 'lodash';
import moment from 'moment';
import SessionStorage from '../../../api/session-storage';
import {
  TEST_ENGINE_PSIUTD,
  TEST_ENGINE_ACTTAO,
  TEST_ENGINE_QUALTRICS,
} from '../../../api/types';

let updateTimeout;
class TestField extends React.Component {
  componentDidMount() {
    this.retryAllowedAttempts = this.props.rp_session_status_retry_limit;
    if (document.getElementById('test-field-1')) {
      setTimeout(() => {
        document.getElementById('test-field-1');
      }, 200);
    }
    if (this.props.autoLaunchIn !== undefined) {
      setTimeout(() => {
        this.checkIfValidLaunch();
      }, this.props.autoLaunchIn * 1000);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps, this.props) &&
      this.props.autoLaunchIn !== undefined
    ) {
      if (!updateTimeout) {
        updateTimeout = setTimeout(() => {
          this.checkIfValidLaunch();
        }, this.props.autoLaunchIn * 1000);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keySelect);
    clearTimeout(updateTimeout);
    this.clearRetryInterval();
  }

  getFormForPSIUTD = (postBody, url, authToken) => {
    if (!postBody) {
      this.setState({ hasError: true });
      return;
    }
    const data = JSON.parse(postBody);
    const form = document.createElement('form');
    form.action = url;
    form.method = 'POST';

    //Add authorization header
    let element = document.createElement('input');
    element.type = 'hidden';
    element.name = 'Authorization';
    element.value = authToken;
    form.appendChild(element);

    Object.keys(data).forEach(function (key) {
      element = document.createElement('input');
      element.type = 'hidden';
      element.name = key;
      element.value = data[key];
      form.appendChild(element);
    });
    document.body.appendChild(form);
    form.submit();
  };

  getFormForACTTAO = (data, url) => {
    const arr = data.split('&');
    let newArr = [];
    const form = document.createElement('form');
    form.action = url;
    form.method = 'POST';

    for (let i = 0; i < arr.length; i++) {
      newArr.push(arr[i].split('='));
    }
    for (let i = 0; i < newArr.length; i++) {
      var element = document.createElement('input');
      element.type = 'hidden';
      element.name = newArr[i][0];
      element.value = decodeURIComponent(newArr[i][1]);
      form.appendChild(element);
    }
    document.body.appendChild(form);
    form.submit();
  };

  handleLaunch = async body => {
    const { field, token, admin, regId } = this.props;
    const requestBody = JSON.stringify({
      test_launch_id: field.test_launch_id,
      admin_id: admin,
      label: field.label,
      requester: 'PORTAL',
      reason: 'NORMAL',
      status: 'L',
      taken_order_id: this.props.getOrderNumber(),
    });
    SessionStorage.removeStopTime();
    Requests.putAssessment(requestBody, regId, token);
    switch (field.launch_engine) {
      case TEST_ENGINE_ACTTAO:
        //D2L-624 use launchString for /sign endpoint for LTI signing
        this.getFormForACTTAO(body.launchString, field.launch_url);
        //use ltistring if you are calling /ledata for lti signing
        //this.getFormForACTTAO(body.ltistring, field.launch_url)
        break;
      case TEST_ENGINE_PSIUTD:
        this.getFormForPSIUTD(
          field.post_body,
          field.launch_url,
          body.authtoken,
        );
        break;
      case TEST_ENGINE_QUALTRICS:
        window.location.href = field.launch_url;
        break;
      default:
        this.setState({ hasError: true });
        break;
    }
  };

  sign = async () => {
    const { field, token } = this.props;

    //For launch engine that does not require any signature. For now it is only qualtrics
    if (field.launch_engine === TEST_ENGINE_QUALTRICS) {
      await this.handleLaunch();
      return;
    }

    var response;
    if (field.launch_engine === TEST_ENGINE_PSIUTD) {
      response = await Requests.ledata(field, token);
    } else if (field.launch_engine === TEST_ENGINE_ACTTAO) {
      //D2L-624 the /ledata is cached at apigateway to avoid making calls again and again for the PSIUTD case.
      // to move past caching, we introduced a Launch-Engine header with unique guid when called for TAO engine.
      // But API gateway is not looking at the difference in header to not use cache but make the integration call. Due
      // to this reason we are getting an invalid LTI sign error. To fix this we aer reverting the code back to using
      // the /sign API which was originally created for LTI signing.
      //response = await Requests.ledata(field, token)
      response = await Requests.sign(field, token);
    }
    const { ok, json: body, status } = response;
    if (ok) {
      if (status === 200) {
        await this.handleLaunch(body);
      }
    } else {
      if (status === 400 || status === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (status === 500) {
        this.setState({ hasError: true });
      }
    }
  };

  signEnter = event => {
    if (event.key === 'Enter') {
      this.checkIfValidLaunch();
    }
  };

  checkIfValidLaunch = () => {
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
    const { field, checkIfOtherAssessmentLaunchExists } = this.props;
    let { now } = this.props;
    if (!now && this.props.timezone === 'local') {
      now = moment();
    }
    //check if you are opening the test in the coresponding time interval
    if (this.props.notAfterEnd && now.isAfter(this.props.notAfterEnd)) {
      this.props.setInvalidLaunchTime(
        `Valid launch time until ${this.props.notAfterEnd.format('HH:mm')}`,
      );
      if (this.retryIntervalID) {
        this.clearRetryInterval();
      }
    } else if (
      (this.props.notBeforeEarly && now.isBefore(this.props.notBeforeEarly)) ||
      (this.props.notBeforeEarly && now.isAfter(this.props.notAfterEarly))
    ) {
      this.props.setInvalidLaunchTime(
        `Valid launch time: ${this.props.notBeforeEarly !== '' ? this.props.notBeforeEarly.format('HH:mm') : ''} - ${this.props.notAfterEarly !== '' ? this.props.notAfterEarly.format('HH:mm') : ''}`,
      );
      if (this.retryIntervalID) {
        this.clearRetryInterval();
      }
    } else {
      if (!checkIfOtherAssessmentLaunchExists(field)) {
        this.checkRPSessionStatus()
          .then(response => {
            if (response === true) {
              this.sign();
            }
          })
          .catch(error => {
            return error;
          });
      }
    }
  };

  clearRetryInterval = () => {
    clearInterval(this.retryIntervalID);
    this.retryIntervalID = 0;
  };

  tickRetry = async () => {
    if (this.retryAllowedAttempts > 0) {
      this.retryAllowedAttempts--;

      const admin = {
        admin_id: this.props.admin,
        reg_id: this.props.regId,
        token: this.props.token,
      };

      const {
        ok: userReceived,
        json: userData,
        status: userRequestStatus,
      } = await Requests.getUser(admin);

      if (userReceived) {
        if (userData.rp_session_status === 'A') {
          if (this.retryIntervalID) {
            this.clearRetryInterval();
          }
          this.sign();
        }
      } else {
        if (this.retryIntervalID) {
          this.clearRetryInterval();
        }
        if (userRequestStatus === 400 || userRequestStatus === 403) {
          this.setState({ hasInvalidParams: true });
        }
        if (userRequestStatus === 500) {
          this.setState({ hasError: true });
        }
      }
    } else {
      if (this.retryIntervalID) {
        this.clearRetryInterval();
      }
    }
  };

  checkRPSessionStatus = async () => {
    const admin = {
      admin_id: this.props.admin,
      reg_id: this.props.regId,
      token: this.props.token,
    };

    const {
      ok: userReceived,
      json: userData,
      status: userRequestStatus,
    } = await Requests.getUser(admin);
    if (userReceived) {
      if (this.retryAllowedAttempts === undefined) {
        this.retryAllowedAttempts = userData.rp_session_status_retry_limit;
      }
      if (userData.rp_session_status === 'A') {
        if (this.retryIntervalID) {
          this.clearRetryInterval();
        }
        return true;
      } else if (userData.rp_session_status === 'P') {
        if (!this.retryIntervalID) {
          this.retryIntervalID = setInterval(
            this.tickRetry.bind(this),
            userData.rp_session_status_retry_duration * 1000,
          );
        }
        return false;
      }
    } else {
      if (userRequestStatus === 400 || userRequestStatus === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (userRequestStatus === 500) {
        this.setState({ hasError: true });
      }
    }

    return false;
  };

  render() {
    const { field, isSequential, index } = this.props;
    const fieldClass = classNames(
      'test-field',
      { completed: field.status_fl === 'C' },
      { available: field.status_fl === 'A' || field.status_fl === 'L' },
      { unavailable: field.status_fl === 'X' },
      { terminated: field.status_fl === 'T' },
      { 'sequential completed': field.status_fl === 'C' && isSequential },
    );

    let statusText;
    let notificationText;
    switch (field.status_fl) {
      case 'C':
        statusText = 'COMPLETED';
        notificationText = `Disabled with the status ${statusText}`;
        break;
      case 'A':
        statusText = 'START';
        notificationText = `Enabled with the status ${statusText}`;
        break;
      case 'L':
        statusText = 'RESUME';
        notificationText = `Enabled with the status ${statusText}`;
        break;
      case 'T':
        statusText = 'TERMINATED';
        notificationText = `Disabled with the status ${statusText}`;
        break;
      default:
        statusText = '';
        notificationText = `Disabled`;
    }

    return (
      <div
        onClick={this.checkIfValidLaunch}
        onKeyUp={this.signEnter}
        className={fieldClass}
        id={`test-field-${index}`}
        aria-label={`${field.label} ${notificationText}`}
        role="button"
        tabIndex="0"
      >
        <div className="test-label">{field.label}</div>
        <div className="test-status">
          <div className="status-text" aria-hidden="true">
            {statusText}
          </div>
          <div className="status-icon"></div>
        </div>
      </div>
    );
  }
}
export default TestField;
